import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=243d9933&scoped=true"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&id=243d9933&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d9933",
  null
  
)

export default component.exports